export function Header(): ReactElement {
  return (
    <a href="/" className="text-3xl font-bold">
      TypeScript Practice
    </a>
  );
}
